/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  Existed,
  MapString,
  MapStringString,
  OauthLocation,
  TeamsConnection,
  TeamsConnections,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "microsoft-teams";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description Get Teams connection
   *
   * @tags connections
   * @name GetTeamsConnection
   * @request GET:/v1/tenant/{tenantId}/oauth/connection
   * @secure
   */
  getTeamsConnection = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      TeamsConnection,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/oauth/connection`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getTeamsConnection */
  getTeamsConnectionPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/oauth/connection`);

  /**
   * @description Delete Teams connection
   *
   * @tags connections
   * @name DeleteTeamsConnection
   * @request DELETE:/v1/tenant/{tenantId}/oauth/connection
   * @secure
   */
  deleteTeamsConnection = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      Existed,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/oauth/connection`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteTeamsConnection */
  deleteTeamsConnectionPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/oauth/connection`);

  /**
   * @description Get Teams connections for a list of users
   *
   * @tags connections
   * @name GetTeamsConnectionsForAListOfUsers
   * @request POST:/v1/tenant/{tenantId}/oauth/connections
   * @secure
   */
  getTeamsConnectionsForAListOfUsers = (tenantId: string, data?: string[], params: RequestParams = {}) =>
    this.request<
      TeamsConnections,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/oauth/connections`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getTeamsConnectionsForAListOfUsers */
  getTeamsConnectionsForAListOfUsersPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/oauth/connections`);

  /**
   * @description Initiate OAuth
   *
   * @tags oauth
   * @name InitiateOAuth
   * @request GET:/v1/tenant/{tenantId}/oauth/initiate
   * @secure
   */
  initiateOAuth = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      OauthLocation,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/oauth/initiate`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for initiateOAuth */
  initiateOAuthPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/oauth/initiate`);

  /**
   * @description Complete OAuth
   *
   * @tags oauth
   * @name CompleteOAuth
   * @request GET:/v1/public/oauth/callback
   */
  completeOAuth = (
    query: {
      /** @minLength 1 */
      code?: string;
      /** @minLength 1 */
      error?: string;
      /** @minLength 1 */
      state: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      any,
      | void
      | string
      | (
          | {
              errorCode: string;
              errorMessage: string;
              arguments?: MapString;
              data?: any;
            }
          | {
              errorCode: string;
              errorMessage: string;
              arguments?: MapStringString;
            }
        )
    >({
      path: `/v1/public/oauth/callback`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Returns string containing request path for completeOAuth */
  completeOAuthPathGetter = (query: {
    /** @minLength 1 */
    code?: string;
    /** @minLength 1 */
    error?: string;
    /** @minLength 1 */
    state: string;
  }) => this.getServicePath(`/v1/public/oauth/callback`, query);
}
